module.exports = __webpack_public_path__ + "static/img/a3.48c4495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/safe/a3.png
// module id = kdSe
// module chunks = 1